import { render, staticRenderFns } from "./consulting.vue?vue&type=template&id=00dda0b5&scoped=true&"
import script from "./consulting.vue?vue&type=script&lang=js&"
export * from "./consulting.vue?vue&type=script&lang=js&"
import style0 from "./consulting.vue?vue&type=style&index=0&id=00dda0b5&scoped=true&lang=css&"
import style1 from "./consulting.vue?vue&type=style&index=1&id=00dda0b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dda0b5",
  null
  
)

export default component.exports